"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Toggle;

var _styledSystem = require("styled-system");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  position: relative;\n  transition: all 0.6s;\n  border-radius: 25px;\n  cursor: pointer;\n  &:before {\n    transition: all 0.25s;\n    display: block;\n    position: absolute;\n    content: '';\n    height: 100%;\n    width: calc(100% / 2);\n    transform: translateX(0%) scale(0.8);\n    left: 0px;\n    top: 0px;\n    background-color: white;\n    transition-delay: 0.01s;\n    border-radius: 50%;\n  }\n  ", " && {\n    &:before {\n      transform: translateX(100%) scale(0.8);\n    }\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var switchSize = (0, _styledSystem.variant)({
  key: 'switchSizes',
  prop: 'switchSize'
});
var Switch = (0, _styledComponents["default"])(_Box["default"])(_templateObject(), switchSize, function (props) {
  return props.checked === false;
}, function (props) {
  return props.disabled && "pointer-events: none;\n    opacity: 0.7;\n    background: gray;";
});
Switch.defaultProps = {
  switchSize: 'small',
  display: 'inline-flex',
  flex: 'none'
};

function Toggle(_ref) {
  var switchSize = _ref.switchSize,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? false : _ref$initialValue,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      rest = _objectWithoutProperties(_ref, ["switchSize", "initialValue", "onClick"]);

  var _React$useState = _react["default"].useState(initialValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      toggle = _React$useState2[0],
      setToggle = _React$useState2[1];

  return /*#__PURE__*/_react["default"].createElement(Switch, _extends({
    checked: toggle,
    bg: toggle ? 'success' : 'neutral',
    switchSize: switchSize,
    onClick: function onClick() {
      setToggle(!toggle);

      _onClick();
    }
  }, rest));
}